<template>
  <v-container
    style="max-width: 30em; margin-top: 5em;"
  >
    <material-card>
      <v-avatar
        slot="offset"
        class="mx-auto d-block"
        size="130"
        tile
      >
        <img
          src="logo_newmat.svg"
        >
      </v-avatar>
      <v-flex
        xs12
        md12
      >
        <v-text-field
          v-model="courriel"
          :rules="[rules.required, rules.email]"
          label="Courriel"
        />
      </v-flex>
      <v-flex
        xs12
        md12
      >
        <v-text-field
          v-model="password"
          :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
          :rules="[rules.required, rules.min]"
          :type="show ? 'text' : 'password'"
          name="input-10-1"
          label="Mot de passe"
          hint="Au moins 8 caractères"
          counter
          @click:append="show = !show"
        />
        <v-btn
          color="success"
          rounded
          block
          class="font-weight-light full-width"
          @click="submit()"
        >
          Connexion
        </v-btn>
      </v-flex>
      <v-alert
        :value="invalidlog"
        dense
        outlined
        type="error"
      >
        Ces identifiants sont invalides.
      </v-alert>
    </material-card>
    <v-btn
      color="info"
      rounded
      block
      class="font-weight-light full-width"
      @click="retourSite()"
    >
      retour au site
    </v-btn>
  </v-container>
</template>

<script>
import { auth } from '@/plugins/firebase'

export default {
  data () {
    return {
      show: false,
      invalidlog: false,
      courriel: '',
      password: '',
      rules: {
        required: value => !!value || 'Champs requis.',
        min: v => v.length >= 8 || 'Min 8 caractères',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Courriel invalide.'
        }
      }
    }
  },
  methods: {
    retourSite () {
      this.$router.push('/')
    },
    submit () {
      auth.signInWithEmailAndPassword(this.courriel, this.password)
        .then(data => {
          this.$router.push('/')
        })
        .catch(err => {
          this.error = err.message
          this.invalidlog = true
        })
    }
  }
}
</script>
